import React, { useState, useEffect } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import dayjs from "dayjs";
import "./style.scss";

const CustomTimePicker = ({
  onChange,
  placeholder = "Select or enter time (HH:MM)",
  selectedTime,
  isDisabled = false,
  handleBlur,
  isError,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [tempTime, setTempTime] = useState(null);

  // Sync selectedTime prop with tempTime state
  useEffect(() => {
    if (selectedTime) {
      setTempTime(dayjs(selectedTime, "HH:mm:ss"));
    }
  }, [selectedTime]);

  // Update tempTime on change
  const handleTimeChange = (newValue) => {
    setTempTime(newValue);
    const totalMins = newValue.hour() * 60 + newValue.minute();
    onChange(totalMins)
  };

  // Handle OK button click
  const handleAccept = (acceptedTime) => {    
    if (acceptedTime) {
      const totalMins = acceptedTime.hour() * 60 + acceptedTime.minute();
      onChange(totalMins);
      setIsOpen(false); // Close picker on OK
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div
        className={`time-input-component ${isError ? "error-container" : ""} cursor-pointer`}
        tabIndex={0}
        onClick={() => setIsOpen(true)}
      >
        <TimePicker
          value={tempTime}
          views={["hours", "minutes"]}
          open={isOpen}
          onChange={handleTimeChange}
          onAccept={handleAccept}
          onClose={() => setIsOpen(false)} // Ensure picker closes on outside click or OK
          ampm={false}
          disableCloseOnSelect
          closeOnSelect={false}
          desktopModeMediaQuery="(min-width: 0px)" // Force desktop mode on all screen sizes
          sx={{
            "& .MuiInputBase-input": {
              fontSize: "12px",
            },
          }}
          slotProps={{
            textField: {
              placeholder: placeholder,
              onBlur: handleBlur,
              readOnly: true, // Prevent manual input
            },
            popper: {
              sx: {
                "& .MuiPaper-root": {
                  borderRadius: "8px",
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.4)",
                },
                "& .MuiClock-root": {
                  backgroundColor: "#f3f4f6",
                },
                "& .MuiPickersClock-pin": {
                  backgroundColor: "#6a0dad",
                },
                "& .MuiButtonBase-root": {
                  backgroundColor: "#fff",
                  fontSize: "12px",
                  borderRadius: "8px",
                },
                "& .Mui-selected ": {
                  backgroundColor: "#6C5DD3 !important",
                  color: "#fff !important",
                },
                "& .MuiButtonBase-root:hover": {
                  backgroundColor: "#F5F6FA",
                },
                "& .MuiTypography-root": {
                  color: "#333",
                },
                "& .MuiButtonBase-root.MuiButton-root": {
                  color: "#6C5DD3",
                  backgroundColor: "#F5F6FA",
                },
                '& .MuiDialogActions-root': {
                  display : 'none'
                }
              },
            },
            actionBar: {
              actions: [''], // Ensure OK (Accept) button is visible
            },
          }}
          className="time-picker"
        />
      </div>
    </LocalizationProvider>
  );
};

export default CustomTimePicker;